import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// redux
import { useDispatch, useSelector } from "react-redux";
import * as actions from "./store/actions/index";
import setAuthToken from "./utils/setAuthToken";

// Components
// ### user
import Home from "./pages/client/home/Home";
import Projects from "./pages/client/projects/Projects";
import Documents from "./pages/client/documents/Documents";

// general
import Profile from "./pages/profile/Profile";
import Login from "./pages/auth/login/Login";

// ### admin
import Dashboard from "./pages/admin/dashboard/Dashboard";
import Clients from "./pages/admin/clients/Clients";
import Client from "./pages/admin/client/Client";
import Files from "./pages/admin/files/Files";
import CreateProject from "./pages/admin/project/CreateProject";
import CreateTask from "./pages/admin/project/tasks/CreateTask";
import TimeTracker from "./pages/admin/timeTracker/TimeTracker";
import ProjectTimeTracker from "./pages/admin/timeTracker/projectTimeTracker/ProjectTimeTracker";
import Managers from "./pages/admin/managers/Managers";
import CreateClient from "./pages/admin/createClient/CreateClient";
import CreateManager from "./pages/admin/createManager/CreateManager";
import PageNotFound from "./pages/404/PageNotFound";
import Logout from "./pages/auth/logout/Logout";
import CreateFolder from "./pages/admin/project/folders/CreateFolder";
import UserFiles from './pages/client/userFiles/UserFiles';
import UserCreateFolder from './pages/client/folder/CreateFolder';
import UserRenameFolder from './pages/client/folder/renameFolder/RenameFolder'
import RenameFolder from './pages/admin/files/renameFolder/RenameFolder';

const Routes = () => {
  const dispatch = useDispatch();
  const [appFirstLoad, setAppFirstLoad] = useState(false);
  const tokenStorage = localStorage.token;
  // console.log(tokenStorage);
  useEffect(() => {
    dispatch(actions.authCheckState());
    if (tokenStorage) {
      setAuthToken(tokenStorage);
    }
    setAppFirstLoad(true);
  }, [dispatch, tokenStorage]);
  const isAuthenticated = useSelector((state) => state.auth.role);
  // const isAuthenticated = true;

  const client = (
    <Switch>
      <Route
        exact
        path="/documents/folder/:folderId/:folderName"
        component={UserFiles}
      />
      <Route
        exact
        path="/documents/:clientId/folder-profile"
        component={UserCreateFolder}
      />
        <Route
        exact
        path="/documents/folder/:folderId/:folderName/rename-profile"
        component={UserRenameFolder}
      />
      
      <Route exact path="/" component={Home} />
      {/* <Route path="/projects" component={Projects} /> */}
      <Route path="/documents" component={Documents} />
      <Route path="/profile" component={Profile} />
      <Route path="/logout" component={Logout} />
      <Route path="/404" component={PageNotFound} />
      <Redirect from="/*" to="/404" />
    </Switch>
  );
  // console.log(isAuthenticated);

  const login = (
    <Switch>
      <Route path="/login" component={Login} />
      <Redirect to="/login" />
    </Switch>
  );

  const admin = (
    <Switch>
      <Route exact path="/" component={Dashboard} />
      <Route exact path="/clients" component={Clients} />
      <Route exact path="/clients/:clientId" component={Client} />
      <Route
        exact
        path="/clients/:clientId/client-project"
        component={CreateProject}
      />
      <Route
        exact
        path="/clients/:clientId/task-profile"
        component={CreateTask}
      />
      <Route
        exact
        path="/clients/:clientId/folder-profile"
        component={CreateFolder}
      />
      <Route
        exact
        path="/time-tracker/:clientId/:projectId/:projectName"
        component={ProjectTimeTracker}
      />
      <Route
        exact
        path="/clients/:clientId/folder/:folderId/:folderName"
        component={Files}
      />
      <Route
        exact
        path="/clients/:folderId/:folderName/rename-profile"
        component={RenameFolder}
      />
      
      <Route path="/time-tracker" component={TimeTracker} />
      <Route path="/managers" component={Managers} />
      <Route path="/profile" component={Profile} />
      <Route path="/create-client" component={CreateClient} />
      <Route path="/create-manager" component={CreateManager} />
      <Route path="/logout" component={Logout} />
      <Route path="/404" component={PageNotFound} />
      <Redirect from="/*" to="/404" />
    </Switch>
  );
  let mainRoute = null;
  if (isAuthenticated === "admin" || isAuthenticated === "superAdmin") {
    mainRoute = admin;
  }
  if (isAuthenticated === "client") {
    mainRoute = client;
  }
  return isAuthenticated && appFirstLoad ? mainRoute : appFirstLoad && login;
};

export default Routes;
